import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

export var FetchResponse = /*#__PURE__*/function () {
  function FetchResponse(response) {
    _classCallCheck(this, FetchResponse);

    this.response = response;
  }

  _createClass(FetchResponse, [{
    key: "statusCode",
    get: function get() {
      return this.response.status;
    }
  }, {
    key: "redirected",
    get: function get() {
      return this.response.redirected;
    }
  }, {
    key: "ok",
    get: function get() {
      return this.response.ok;
    }
  }, {
    key: "unauthenticated",
    get: function get() {
      return this.statusCode === 401;
    }
  }, {
    key: "authenticationURL",
    get: function get() {
      return this.response.headers.get('WWW-Authenticate');
    }
  }, {
    key: "contentType",
    get: function get() {
      var contentType = this.response.headers.get('Content-Type') || '';
      return contentType.replace(/;.*$/, '');
    }
  }, {
    key: "headers",
    get: function get() {
      return this.response.headers;
    }
  }, {
    key: "html",
    get: function get() {
      if (this.contentType.match(/^(application|text)\/(html|xhtml\+xml)$/)) {
        return this.text;
      }

      return Promise.reject(new Error("Expected an HTML response but got \"".concat(this.contentType, "\" instead")));
    }
  }, {
    key: "json",
    get: function get() {
      if (this.contentType.match(/^application\/json/)) {
        return this.responseJson || (this.responseJson = this.response.json());
      }

      return Promise.reject(new Error("Expected a JSON response but got \"".concat(this.contentType, "\" instead")));
    }
  }, {
    key: "text",
    get: function get() {
      return this.responseText || (this.responseText = this.response.text());
    }
  }, {
    key: "isTurboStream",
    get: function get() {
      return this.contentType.match(/^text\/vnd\.turbo-stream\.html/);
    }
  }, {
    key: "renderTurboStream",
    value: function () {
      var _renderTurboStream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.isTurboStream) {
                  _context.next = 12;
                  break;
                }

                if (!window.Turbo) {
                  _context.next = 9;
                  break;
                }

                _context.t0 = window.Turbo;
                _context.next = 5;
                return this.text;

              case 5:
                _context.t1 = _context.sent;

                _context.t0.renderStreamMessage.call(_context.t0, _context.t1);

                _context.next = 10;
                break;

              case 9:
                console.warn('You must set `window.Turbo = Turbo` to automatically process Turbo Stream events with request.js');

              case 10:
                _context.next = 13;
                break;

              case 12:
                return _context.abrupt("return", Promise.reject(new Error("Expected a Turbo Stream response but got \"".concat(this.contentType, "\" instead"))));

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function renderTurboStream() {
        return _renderTurboStream.apply(this, arguments);
      }

      return renderTurboStream;
    }()
  }]);

  return FetchResponse;
}();